module.exports = __webpack_public_path__ + "fonts/iconfont.ca3d0c7b.eot";